const SwiperData = [
    {
        img:"http://res.cloudinary.com/dpkdi73b4/image/upload/v1701931892/cecve6a6mgdrwdnwnkbi.jpg"
    },
    {
        img:"http://res.cloudinary.com/dpkdi73b4/image/upload/v1701931847/heh5b1qjeskyq1rftye3.jpg"
    },
    {
        img:"http://res.cloudinary.com/dpkdi73b4/image/upload/v1701931921/mdlthlk7a6hjltjsle8e.jpg"
    },
    {
        img:"http://res.cloudinary.com/dpkdi73b4/image/upload/v1701931892/cecve6a6mgdrwdnwnkbi.jpg"
    }
]

export default SwiperData